import { gql } from '@urql/core';

export const AccountUserProfileFragment = gql`
	fragment AccountUserProfileFragment on GrowthUnifiedProfileAccountProfileResult {
		userProfile {
			inferredTimezone
		}
	}
`;
